import React from 'react';

import { PageTitle } from '../../../components';
import { Tickets } from '../..';



const TicketPage = () => {  
  return (   
    <> 

      {/* Page Title */}
      <PageTitle title={'Tickets'} page={'Tickets'} />
      
      {/* Ticket Section */}
      <Tickets />
      
    </>
  )
}

export default TicketPage;